export enum EnSocialMediaType {
  Instagram = 'INSTAGRAM',
  Facebook = 'FACEBOOK',
  Youtube = 'YOUTUBE',
  Discord = 'DISCORD',
  Email = 'EMAIL',
  Phone = 'PHONE',
  Website = 'WEBSITE',
  TikTok = 'TIKTOK',
  Pinterest = 'PINTEREST',
  Snapchat = 'SNAPCHAT',
  Twitter = 'TWITTER',
  LinkedIn = 'LINKEDIN',
  WKO = 'WKO',
  // Whatsapp = 'WHATSAPP',
  Telegram = 'TELEGRAM'
}
